import {Page} from '../page';
import {IPurchaseService} from '../../services/purchase';
import {ApiError} from '../../services/api';
import {getDropinErrorMessage} from '../../services/purchase/errorMessage';
import {AuthService} from '../../services/authService';
import {ITranslateService} from '../../services/translateService';
import {ISessionService} from '../../services/session';
import {IUserService} from '../../services/user';
import {ITrackingService} from '../../services/gtmHelper';
import {EnvConfig} from '../../config/envConfig.interface';
import {IBindingService} from '../../services/bindingService';

export abstract class PurchasePage extends Page {
  public afterUserLoggedIn(): void {}

  constructor(
    protected configuration: EnvConfig,
    protected authService: AuthService,
    protected translateService: ITranslateService,
    protected sessionService: ISessionService,
    protected userService: IUserService,
    protected trackingService: ITrackingService,
    protected purchaseService: IPurchaseService,
    protected bindingService: IBindingService,
  ) {
    super(
      configuration,
      authService,
      bindingService,
      userService,
      trackingService,
    );

    void this.alwaysForceUser().then(() => {
      // start the loop
      void this.purchaseService.keepAwakeLoop();

      this.afterUserLoggedIn();
    });
  }

  protected dropinErrorToMsg(err: ApiError): string | null {
    return getDropinErrorMessage(err);
  }
}
